'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var Border = require('../common/Border');
var styleHelper = require('../../helper/styleHelper');
var measureHelper = require('../../helper/measureHelper');
//var Dom = require('react-dom');
var LabelParts = require('../common/LabelParts');
var convertHelper = require('../../types/convertHelper');
var textHelper = require('../../helper/util').Text;
var appTypes = require('../../types/appTypes');

var Label = React.createClass({
  componentWillReceiveProps: function (nextProps) {
    //if (nextProps.text !== this.props.text) {
    this.isInvalid = true;
    //}
  },

  componentDidUpdate: function () {
    if (this.isInvalid) {
      this.isInvalid = false;
      this._doPaint();
    }
    ;
    this.doAdjustLinkArea();
  },

  _doPaint: function () {
    var com;
    var parentDom;
    var w;
    var lineHeight = styleHelper.builderLineHeight(this.props);
    var textHeight;
    if (lineHeight) {
      textHeight = lineHeight + 1;
      lineHeight += 'px';
    } else {
      lineHeight = '1em';
      textHeight = 14;
    }

    var style;
    com = ReactDOM.findDOMNode(this);
    if (this.props.isAutoSize) {
      parentDom = com.parentElement;
      if (parentDom) {
        style = styleHelper.builderTextStyle(this.props);
        w = measureHelper.measureTextWidth(style, styleHelper.getText(this.props)).width;
        if (w) {
          $(parentDom).css({width: w, height: textHeight, lineHeight: lineHeight});
        }
        ;
      }
      ;
    }
    ;
  },

  componentDidMount: function () {
    this._doPaint();
    this.doAdjustLinkArea();
    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize);
  },

  onResize: function (e) {
    this.doAdjustLinkArea();
  },

  doAdjustLinkArea: function () {
    var dom = ReactDOM.findDOMNode(this).parentElement;
    var lbl = ReactDOM.findDOMNode(this.refs.label);
    var w = dom.clientWidth;
    var h = dom.clientHeight;
    if (this.props.isAutoSize) {
      w = lbl.parentElement.clientWidth;
    }
    ;
    dom = $(dom);
    var linkArea = dom.children('.linkArea').first();
    var plink = linkArea.children('.page-link');
    var ilink = linkArea.children('.interactive-link');
    linkArea.css({width: '100%', height: '100%'});
    linkArea.children().css({width: '100%', height: '100%'});
    //plink.css({width:'100%',height:'100%'});
    //ilink.css({width:'100%',height:'100%'});
  },

  render: function () {
    var text = styleHelper.getText(this.props);
    var labelBoxStyle;
    var labelStyle;
    var bgColor = styleHelper.getBackgroundColor(this.props);
    var textAlign;
    var contextStyle = {
      backgroundColor: bgColor,
      position: 'absolute',
      lineHeight: this.props.h + 'px'
    };

    if (!this.props.isAutoSize) {
      contextStyle.overflow = 'hidden';
    }

    text = textHelper.convertSpaceToNbsp(text);

    if (this.props.textAlign === 'HaLeft') {
      textAlign = 'left';
    } else if (this.props.textAlign === 'HaCenter') {
      textAlign = 'center';
    } else if (this.props.textAlign === 'HaRight') {
      textAlign = 'right';
    }

    labelBoxStyle = {
      width: 'auto',
      height: 'auto',
      textAlign: textAlign
    };

    labelStyle = {
      whiteSpace: 'nowrap'
    };

    styleHelper.adjustTextSizeStyle(labelStyle);
    styleHelper.StyleUtil(this.props, labelStyle).align().text();
    return (<div
      id={this.props.id}
      className="context"
      style={contextStyle}
    >
      <div style={labelBoxStyle}>
        <div style={{width: 'auto', height: 'auto'}}>
          <label ref="label" style={labelStyle}>{text}</label>
        </div>
      </div>
    </div>);
  }
});

module.exports = Label;



// WEBPACK FOOTER //
// ./src/views/Components/Label.jsx